import { useMemo } from 'react';

import { useGetNotificationsAlerts } from 'api';

import { useOrganisationId } from 'hooks/context';

import type { AlertType } from '../../atoms/AlertBanner';
import { AlertBanner } from '../../atoms/AlertBanner';

function filterAlertsByType<T extends { alert_type: string }>(
  kind: AlertType,
  alerts?: T[]
) {
  return alerts?.filter((alert) => alert.alert_type === kind);
}

/**
 * You can use this banner to show updates and so on.
 */
export function NewsBanner() {
  const organisationId = useOrganisationId();

  const { data: alerts } = useGetNotificationsAlerts(
    Number(organisationId),
    {}
  );

  const { infos, warnings, errors } = useMemo(
    () => ({
      infos: filterAlertsByType('info', alerts?.data),
      warnings: filterAlertsByType('warning', alerts?.data),
      errors: filterAlertsByType('error', alerts?.data)
    }),
    [alerts]
  );

  return (
    <div>
      <AlertBanner alerts={warnings} kind="warning" />
      <AlertBanner alerts={infos} kind="info" />
      <AlertBanner alerts={errors} kind="error" />
    </div>
  );
}
